var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6175 2.88218C16.8677 2.13237 15.652 2.13237 14.9022 2.88218L7.61982 10.1645V12.8798H10.3351L17.6175 5.59747C18.3673 4.84766 18.3673 3.63199 17.6175 2.88218Z",
    fill: "#BA0060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81982 6.15982C2.81982 5.09944 3.67944 4.23982 4.73982 4.23982H8.57982C9.11002 4.23982 9.53982 4.66963 9.53982 5.19982C9.53982 5.73002 9.11002 6.15982 8.57982 6.15982H4.73982V15.7598H14.3398V11.9198C14.3398 11.3896 14.7696 10.9598 15.2998 10.9598C15.83 10.9598 16.2598 11.3896 16.2598 11.9198V15.7598C16.2598 16.8202 15.4002 17.6798 14.3398 17.6798H4.73982C3.67944 17.6798 2.81982 16.8202 2.81982 15.7598V6.15982Z",
    fill: "#BA0060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/edit-icon2.981e860ab19e2bdb651c8324cb5c2e2b.svg";
export { ForwardRef as ReactComponent };